/**
 * HelpPopover.jsx — Carousel Composer keyboard shortcuts, on demand.
 */

import { useEffect } from 'react';
import { setHelpOpen } from '../../hooks/useCarouselStore';

export default function HelpPopover() {
  useEffect(() => {
    const onDoc = (e) => {
      if (!e.target.closest('.help-pop') && !e.target.closest('.help-btn')) setHelpOpen(false);
    };
    document.addEventListener('click', onDoc);
    return () => document.removeEventListener('click', onDoc);
  }, []);

  return (
    <div className="help-pop" role="dialog" aria-label="Keyboard shortcuts">
      <h3>Shortcuts</h3>
      <dl>
        <dt>G</dt><dd>Switch Library and Carousel</dd>
        <dt>/</dt><dd>Find a frame by name</dd>
        <dt>← → ↑ ↓</dt><dd>Move through frames</dd>
        <dt>Space</dt><dd>Select or deselect a frame</dd>
        <dt>Shift-click</dt><dd>Select a range</dd>
        <dt>Enter</dt><dd>View the frame large</dd>
        <dt>[ &nbsp; ]</dt><dd>Smaller or larger thumbnails</dd>
        <dt>Drag · scroll</dt><dd>Reframe · zoom a photo in a slide</dd>
        <dt>Double-click</dt><dd>Reset that photo’s crop</dd>
        <dt>E</dt><dd>Open Export</dd>
        <dt>Esc</dt><dd>Close, or step back</dd>
      </dl>
    </div>
  );
}
